<template>
  <div
    class="header header-fixed header-logo-app"
    style="transform: translateX(0px); overflow: hidden"
  >
    <a @click="showMainMenu()" data-menu="menu-main" class="header-icon header-icon-1">
      <!-- <i class="fa-solid fa-bars"></i> -->
      <feather type="arrow-left"></feather>
    </a>
    <a href="#" data-back-button="" class="header-title" :title="title">{{ title }}</a>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    ...mapActions(["handleMainMenu"]),
    showMainMenu() {
      this.handleMainMenu({ value: true });
    },
  },
};
</script>
